import { Loader } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

import classes from './ToolDisplay.module.css';
import { usePartStatus } from '#plugin-chat/hooks/usePartStatus.ts';

/**
 * Default status indicator when no slot children are provided.
 * Used when ToolDisplay is rendered as a MessagePrimitive.Parts fallback.
 */
export function DefaultStatus() {
  const { isRunning, isComplete, isCancelled, isError } = usePartStatus();

  if (isRunning) {
    return (
      <>
        <div className={classes.icon}>
          <Loader color="dark.1" size={16} />
        </div>
        <div className={classes.label}>Running...</div>
      </>
    );
  }

  if (isComplete && !isCancelled && !isError) {
    return (
      <>
        <div className={classes.icon}>
          <IconCheck color="var(--mantine-color-green-4)" size={16} />
        </div>
        <div className={classes.label}>Complete</div>
      </>
    );
  }

  if (isCancelled || isError) {
    return (
      <>
        <div className={classes.icon}>
          <IconX color="var(--mantine-color-red-4)" size={16} />
        </div>
        <div className={classes.label}>{isError ? 'Error' : 'Cancelled'}</div>
      </>
    );
  }

  return null;
}
